//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
      pafList:[
        'https://static.soyoung.com/sy-pre/pdfimg01-1573809010312.jpg',
        'https://static.soyoung.com/sy-pre/pdfimg02-1573809010312.jpg',
        'https://static.soyoung.com/sy-pre/pdfimg03-1573809010312.jpg',
        'https://static.soyoung.com/sy-pre/pdfimg04-1573810042674.jpg',
        'https://static.soyoung.com/sy-pre/pdfimg05-1573812606633.jpg',
        'https://static.soyoung.com/sy-pre/pdfimg06-1573809010312.jpg',

      ],
    }
  },
  created() {
  },
	mounted() {

		// this.src.then(pdf => {

		// 	this.numPages = pdf.numPages;
		// });
	}
}

